import classNames from 'classnames'

import { VertSpacerSm, VertSpacerXS } from '@apps-common/components/layout'
import { commonIcons } from '@apps-common/config/icons'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_MANAGE } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  bgClasses: string
  textClasses: string
  iconClasses: string
  bgSecondaryClasses: string
  textSecondaryClasses: string
  bgTertiaryClasses: string
  unit: IPortalUnitSearchModel
}

export const UnitListCardSm: React.FC<IProps> = (props) => {
  const { bgClasses, textClasses, bgSecondaryClasses, textSecondaryClasses, bgTertiaryClasses, unit } = props
  const { status, unitId, accountNo, mobileNo, monitoringCentre, productImageUrl, siteName } = unit
  const { navigateForward } = useNavigation()

  const mcName = monitoringCentre || 'Monitoring Centre'
  const ChipIcon = commonIcons.processor
  const ArrowIcon = commonIcons.arrowRight

  return (
    <div
      className={classNames('rounded-[40px] px-5 py-4 hover:cursor-pointer', bgClasses)}
      onClick={(e) => {
        e?.stopPropagation()
        navigateForward({ routeUrl: ROUTE_UNIT_MANAGE.buildPath(status, unitId), route: ROUTE_UNIT_MANAGE })
      }}
    >
      <div className='flex items-center justify-between'>
        <h4 className={classNames('jost-light text-[0.85rem] text-ellipsis whitespace-nowrap overflow-hidden', textClasses)}>{mcName}</h4>
      </div>
      <div className='flex items-center justify-between gap-[5px]'>
        <div
          className={classNames('px-3 py-1 h-[20px] rounded-[15px] flex items-center justify-start gap-[10px] min-w-0', bgSecondaryClasses)}
        >
          <ChipIcon className={classNames('text-[0.9rem] min-w-[0.9rem]', textSecondaryClasses)} />
          <h5 className={classNames('jost-light text-[0.85rem]', textSecondaryClasses)}>{accountNo}</h5>
        </div>
        <div className={classNames('w-[45px] h-[45px] rounded-[23px] flex items-center justify-center', bgSecondaryClasses)}>
          {productImageUrl && <img src={productImageUrl} alt={`Product ${accountNo}}`} className={classNames('max-w-[30px]')} />}
        </div>
      </div>
      <VertSpacerXS />
      <p className={classNames('jost-light text-[0.85rem] text-ellipsis whitespace-nowrap overflow-hidden', textClasses)}>
        {siteName || 'No Site Info'}
      </p>
      <p className={classNames('jost text-[0.75rem] text-ellipsis whitespace-nowrap overflow-hidden', textClasses)}>{mobileNo}</p>
      <VertSpacerSm />
      <button
        type='button'
        className={classNames(
          'jost-light text-[0.9rem] flex items-center justify-between p-4 h-[30px] rounded-[15px] w-full',
          bgSecondaryClasses,
          textSecondaryClasses
        )}
      >
        See details
        <div
          className={classNames(
            'w-[20px] h-[20px] rounded-[15px] flex items-center justify-center',
            bgTertiaryClasses,
            textSecondaryClasses
          )}
        >
          <ArrowIcon />
        </div>
      </button>
    </div>
  )
}
